import { Thead as ChakraThead } from "@chakra-ui/react";

export const Thead = ChakraThead;
